import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISubUser } from '../../api-services/user-mgt/models/account.model';
import { SubRole } from '../../interfaces/user';

@Component({
  selector: 'app-sub-users-table',
  templateUrl: './sub-users-table.component.html'
})
export class SubUsersTableComponent {
  @Input() subUsers: ISubUser[] = [];
  @Input() showActions = false;
  @Output() toggleStatus = new EventEmitter<ISubUser>();

  readonly subRole = SubRole;
}
